import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "../../components/design/design-system";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  border-radius: 8px;
  margin: 20px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  margin-bottom: 16px;
`;

const Message = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  text-align: center;
  max-width: 500px;
  margin-bottom: 12px;
`;

const SubMessage = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  text-align: center;
  max-width: 500px;
`;

const LinkText = styled.a`
  color: ${COLOR_SYSTEM.get("Blue")?.[500]};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const BEERS2023: React.FC = () => {
  return (
    <Container>
      <Title>BEERS 콘텐츠 제공 불가</Title>
      <Message>
        BEERS 2023 원본 콘텐츠를 표시할 수 없습니다.
      </Message>
      <SubMessage>
        원문은 공식 문서에서 확인하시기 바랍니다.
      </SubMessage>
      <SubMessage style={{ marginTop: "20px" }}>
        자세한 내용은{" "}
        <LinkText 
          href="https://agsjournals.onlinelibrary.wiley.com/doi/epdf/10.1111/jgs.18372" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          BEERS Criteria 2023 공식 문서
        </LinkText>
        를 참조하세요.
      </SubMessage>
    </Container>
  );
};

export default BEERS2023;